var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 240,
    viewBox: "0 0 408 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6611_119607)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: 199.244,
    cy: 119.397,
    rx: 100,
    ry: 140,
    transform: "rotate(-60 199.244 119.397)",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 120,
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 160,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 120,
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232,
    cy: 160,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.25 154.75L229.422 165.25L224.5 160.477",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 120,
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 160,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 32,
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 72,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 32,
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 72,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.25 66.75L173.422 77.25L168.5 72.4773",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 32,
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 72,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.25 66.75L85.4219 77.25L80.5 72.4773",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6611_119607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.5db51f88039142e1db83a229075900fa.svg";
export { ForwardRef as ReactComponent };